export enum TABLE_TYPES {
  INCLUSION = "inclusion",
  TUSSENDOORTJES = "tussendoortjes",
}
